<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <p>
          <span class="bold">No. convenio (CIE): </span>2393360
          <feather-icon icon="CopyIcon" svgClasses="w-5 h-5 text-dark cursor-pointer" class="ml-1"
            @click.stop="copyToClipboard(2393360)" />
        </p>
      </div>
      <div class="vx-col w-full">
        <vs-table ref="jobsTable" stripe :data="allDataReferences.data" noDataText="No hay datos disponibles">
          <div slot="header" class="mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="pager" v-if="allDataReferences.data.length > 0">
              <div class="flex flex-wrap">
                <vs-select @input="pager" v-model.lazy="numberSearchPage" name="numberSearchPage">
                  <vs-select-item :key="index + 1" :value="index + 1" :text="index + 1"
                    v-for="(value, index) in allDataReferences.last_page" class="w-full" />
                </vs-select>
              </div>
            </div>
            <div class="p-3 flex items-center justify-between font-medium">
              <vs-button color="success" class="ml-2" size="small" icon-pack="feather" type="filled"
                @click="popupActivo = true" icon="icon-plus">Nueva Referencia</vs-button>
            </div>
          </div>
          <template slot="thead">
            <vs-th>Referencia</vs-th>
            <vs-th>Monto</vs-th>
            <vs-th>Vencimiento</vs-th>
            <vs-th>Estado</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
              <vs-td>
                <div class="flex items-center justify-start">  
                  {{ tr.reference }}
                  <feather-icon icon="CopyIcon" svgClasses="w-5 h-5 text-dark cursor-pointer" class="ml-2 mt-1"
                  @click.stop="copyToClipboard(tr.reference)" />
                </div>
              </vs-td>
              <vs-td>{{ explicitMoneyFormat(tr.amount) }}</vs-td>
              <vs-td>{{ regularDateFormat(tr.valid_until_date) }}</vs-td>
              <vs-td>{{ statusStr(tr.status) }}</vs-td>
            </vs-tr>
          </template>

        </vs-table>
        <div class="mt-3 flex flex-grow justify-end">
          <!-- ITEMS PER PAGE -->
          <div class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg font-small">
            <span>{{ from }} - {{ to }} de {{ totalRecords }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL NUEVA REFERENCIA -->
    <vs-popup class="popup header-primary" title="Nueva referencia BBVA" :active.sync="popupActivo">

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-4">
            <label for class="vs-input--label">Fecha de vencimiento</label><br>
            <small class="ml-1 bold">Todas las referencias creadas estarán vigentes hasta el ultimo día del mes.</small>
            <datepicker placeholder="Fecha inicio" :language="es" v-model="validUntilDate" format="dd/MM/yyyy"
              :disabled="true" />
            <vs-input class="w-full mt-5" label="Monto" v-model="referenceAmount" v-money="money" />
            <div class="mt-3 flex flex-grow justify-end">
              <vs-button color="danger" size="small" type="filled" @click="popupActivo = false">Cancelar</vs-button>
              <vs-button color="success" size="small" class="ml-2" type="filled"
                @click="saveReference">Generar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
    <!--  -->
  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import currencyHelper from "@mixins/currencyHelper";


export default {
  name: "BbvaClientReferences",
  props: {
    applicantId: {
      type: Number,
      required: true
    }
  },
  mixins: [formatHelper, dateHelper, currencyHelper],
  components: { Datepicker },
  data() {
    return {
      es: es,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 2,
        masked: false
      },
      referenceAmount: 0,
      popupActivo: false,
      numberSearchPage: 1,
      allDataReferences: {
        data: [],
        total: 0,
        from: null,
        to: null,
      },
      validUntilDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    }
  },
  computed: {
    eventsFiltered() {
      return this.eventsToShow;
    },
    allEventsProjectHistory() {
      return this.allDataReferences.data;
    },
    from() {
      return this.allDataReferences.from;
    },
    to() {
      return this.allDataReferences.to;
    },
    totalRecords() {
      return this.allDataReferences.total;
    }
  },
  async mounted() {
    this.isMounted = false;
    await this.getReferences();
    this.isMounted = true
  },
  methods: {
    async pager() {
      let url = `api/backoffice/treasury/cash/reference?applicant_id=${this.applicantId}?page=${this.numberSearchPage}`;
      await this.getReferences(url);
    },
    async getReferences(url = `api/backoffice/treasury/cash/reference?applicant_id=${this.applicantId}`) {
      this.buyerInvestorInfoData = "";
      this.showLoading(true);
      try {
        const res = await axios.get(url);
        this.allDataReferences = res.data;
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },

    async saveReference() {
      let referenceAmount = this.unMoneyFormat(this.referenceAmount);
      if (referenceAmount <= 0) {
        this.onError = true;
        this.errorMssg = "Por favor ingresa un monto válido";
        return false;
      }
      this.showLoading(true);
      await axios.post('api/backoffice/treasury/cash/reference', {
        applicant_id: this.applicantId,
        valid_until_date: this.validUntilDate,
        amount: referenceAmount,
      }).then(response => {
        this.showLoading(false);
        this.successNotif("Aviso", 'Referencia generada exitosamente', 4000);
        this.getReferences();
        this.referenceAmount = 0;
        this.popupActivo = false;
      }).catch(error => {
        this.showLoading(false);
        if (error.response.data.message != undefined) {
          this.errorNotif("Aviso", error.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      })
    },
    statusStr(status) {
      var statusStr = "No definido";
      switch (status) {
        case "created":
          statusStr = "Creada";
          break;
        case "expired":
          statusStr = "Expirada";
          break;
        case "payment_applied":
          statusStr = "Aplicada";
          break;
        default:
          break;
      }
      return statusStr;
    },
    async copyToClipboard(value) {
      const el = document.createElement('textarea');
      el.value = value;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.successNotif('Copiado', "Información copiada al portapapeles");
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .vdp-datepicker__calendar {
  position: fixed;
}
</style>